import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ClockCircleOutlined, CheckCircleOutlined, RightOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import ProgressCircleSvg from '../../../assets/icons/progress-circle.svg?raw';
import { Text, Segmented, Button } from '../../../components';
import { NewRMCard } from '../NewRMCard';
import { ROUTE_CONFIG } from '../../../constants/routes';
import { formatCount } from '../../../pages/Discovery/helpers';
import './MigrationStatusCard.scss';

const PERIODS = ['Day', 'Week', 'Month'];
const DEFAULT_PERIOD = PERIODS[0];

export const MigrationStatusCard = ({ migrationData = {} }) => {
    const [period, setPeriod] = useState(DEFAULT_PERIOD);

    const handlePeriodChange = (newPeriod) => {
        setPeriod(newPeriod);
        migrationData.fetchPeriod?.(newPeriod.toLowerCase());
    };

    const { inProgress = 0 } = migrationData;
    const { scheduled = 0, completed = 0, failed = 0, isLoading = false } = migrationData.current || {};

    return (
        <NewRMCard className="migration-status-card" showMoreIcon={false} loading={isLoading}>
            <header>
                <div className="header-left">
                    <Text size="large" color="secondary">
                        Migration Status
                    </Text>
                </div>
                <Segmented
                    options={PERIODS}
                    value={period}
                    onChange={handlePeriodChange}
                    size="small"
                    shape="round"
                />
            </header>
            <div className="migration-status-body">
                <div className="migration-status-left">
                    <div className="in-progress-section">
                        <span className="in-progress-label">
                            <CustomSVG svg={ProgressCircleSvg} className="in-progress-icon" />
                            <Text size="small" color="muted" bold>In Progress</Text>
                        </span>
                        <Text size="extraLarge" xxlBold color="primaryBlue" className="in-progress-count">
                            {formatCount(inProgress)}
                        </Text>
                    </div>
                    <Link to={ROUTE_CONFIG.migrationList.path}>
                        <Button type="primary">
                            View Migrations <RightOutlined />
                        </Button>
                    </Link>
                </div>
                <div className="migration-status-right">
                    {[
                        { icon: <ClockCircleOutlined className="scheduled-icon status-icon" />, label: 'Scheduled', count: formatCount(scheduled) },
                        { icon: <CheckCircleOutlined className="completed-icon status-icon" />, label: 'Completed', count: formatCount(completed) },
                        { icon: <ExclamationCircleOutlined className="failed-icon status-icon" />, label: 'Failed', count: formatCount(failed), countClassName: 'failed-count' },
                    ].map(({ icon, label, count, countClassName = 'status-count' }) => (
                        <div className="status-row" key={label}>
                            <div className="status-header">
                                {icon}
                                <Text size="small" color="muted" bold>{label}</Text>
                            </div>
                            <Text medLarge xxlBold className={countClassName}>{count}</Text>
                        </div>
                    ))}
                </div>
            </div>
        </NewRMCard>
    );
};
